import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { BookFineCollectionComponent } from './book-fine-collection/book-fine-collection.component';
import { BookStockReportComponent } from './book-stock-report/book-stock-report.component';
import { BooksIssueReportComponent } from './books-issue-report/books-issue-report.component';
import { BookslostReportComponent } from './bookslost-report/bookslost-report.component';
import { BookIssuesComponent } from './book-issues/book-issues.component';
import { BookISBNComponent } from './book-isbn/book-isbn.component';
import { JournalsComponent } from './journals/journals.component';
import { CDComponent } from './cd/cd.component';
import { BookComponent } from './book/book.component';
import { BookStatusComponent } from './book-status/book-status.component';
import { GenerateLibraryCardNoComponent } from './generate-library-card-no/generate-library-card-no.component';
import { AuthorComponent } from './author/author.component';
import { BookGruopComponent } from './book-gruop/book-gruop.component';
import { PublicationComponent } from './publication/publication.component';
import { BookEditionComponent } from './book-edition/book-edition.component';
import { BookTitleComponent } from './book-title/book-title.component';
import { BookTypeComponent } from './book-type/book-type.component';
import { LibraryTypeComponent } from './library-type/library-type.component';
import { LibraryConfiguationComponent } from './library-configuation/library-configuation.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'bookfinecollection', component: BookFineCollectionComponent, pathMatch: 'full' },
       { path: 'bookstockreport', component: BookStockReportComponent, pathMatch: 'full' },
       { path: 'booksissuereport', component: BooksIssueReportComponent, pathMatch: 'full' },
      { path: 'bookslostreport', component: BookslostReportComponent, pathMatch: 'full' },
      { path: 'bookissues', component: BookIssuesComponent, pathMatch: 'full' },
      { path: 'bookisbn', component: BookISBNComponent, pathMatch: 'full' },
      { path: 'journals', component: JournalsComponent, pathMatch: 'full' },
      { path: 'cd', component: CDComponent, pathMatch: 'full' },
      { path: 'book', component: BookComponent, pathMatch: 'full' },
      { path: 'bookstatus', component: BookStatusComponent, pathMatch: 'full' },
      { path: 'generatelibrarycardno', component: GenerateLibraryCardNoComponent, pathMatch: 'full' },
      { path: 'author', component: AuthorComponent, pathMatch: 'full' },
      { path: 'bookgruop', component: BookGruopComponent, pathMatch: 'full' },
      { path: 'publication', component: PublicationComponent, pathMatch: 'full' },
      { path: 'bookeddition', component: BookEditionComponent, pathMatch: 'full' },
      { path: 'booktitle', component: BookTitleComponent, pathMatch: 'full' },
      { path: 'booktype', component: BookTypeComponent, pathMatch: 'full' },
      { path: 'librarytype', component: LibraryTypeComponent, pathMatch: 'full' },
      { path: 'libraryconfiguation', component: LibraryConfiguationComponent, pathMatch: 'full' },
      

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LibraryRoutingModule { }
